import script from "./dashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboardView.vue?vue&type=script&setup=true&lang=js"

import "./dashboardView.vue?vue&type=style&index=0&id=0ffad80c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ffad80c"]])

export default __exports__